module.exports = __webpack_public_path__ + "img/datacenter5.3e9e07c9.png";